export default "__VITE_ASSET__MBtPGYbZ__"